
      import Highcharts from "https://cdn.jsdelivr.net/npm/highcharts@5.0.15/+esm";
      window.Highcharts = Highcharts; // make it global

      import momentTimezone from "https://cdn.jsdelivr.net/npm/moment-timezone@0.5.45/+esm";
      window.moment = momentTimezone; // make it global
    